import React from "react";
import { Row, Col } from "react-bootstrap";
import "./Nom035BlockGrade.css";

function Nom035BlockGrade({ title, total, label }) {
  const badgeType = (label) => {
    switch (label) {
      case "Depreciable":
        return "none";

      case "Bajo":
        return "low";

      case "Medio":
        return "middle";

      case "Alto":
        return "high";

      case "Muy Alto":
        return "very-high";

      default:
        break;
    }
  };

  return (
    <Col className="nom035-block-grade">
      <Row className="justify-content-center align-items-center">
        <Col lg={7}>
          <h5>{title}</h5>
        </Col>
        <Col lg={3} className={badgeType(label)}>
          <h5>{label}</h5>
        </Col>
      </Row>
    </Col>
  );
}

export default Nom035BlockGrade;
